if ('IntersectionObserver' in window) {
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      }
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );

  document.querySelectorAll('.js-reveal').forEach((el) => observer.observe(el));

  // Tema düzenleyicide bir bölüm yeniden yüklendiğinde DOM'u tamamen
  // değişiyor: yeni .js-reveal elementleri hiç gözlemlenmemiş olur ve CSS
  // varsayılanı (opacity: 0) yüzünden kalıcı olarak görünmez kalır. O
  // bölümün kendi .js-reveal elementlerini yeniden gözlemliyoruz.
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('.js-reveal').forEach((el) => observer.observe(el));
  });
} else {
  document.querySelectorAll('.js-reveal').forEach((el) => el.classList.add('is-visible'));

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('.js-reveal').forEach((el) => el.classList.add('is-visible'));
  });
}
